import { inject, Injectable } from '@angular/core';
import { LinkItem, NavbarItem } from '../types/navbar.types';
import { LanguageService } from './language.service';
import { SlugService } from './slug.service';
import { ActivatedRoute } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { UmamiService } from './umami.service';

@Injectable({
    providedIn: 'root',
})
export class NavbarService {
    fragment: string | null = null;
    private languageService = inject(LanguageService);
    private slugService = inject(SlugService);
    private activatedRoute = inject(ActivatedRoute);
    private umami = inject(UmamiService);
    private viewportScroller = inject(ViewportScroller);

    constructor() {
        this.activatedRoute.fragment.subscribe((fragment) => {
            if (fragment) {
                this.fragment = fragment;
                setTimeout(() => {
                    this.viewportScroller.scrollToAnchor(fragment);
                }, 100);
            }
        });
    }

    getNavbarLink(linkItem: LinkItem, page: string) {
        if (linkItem.link.startsWith('/')) {
            const linkWithoutFragment = linkItem.link.split('#').shift();
            if (linkWithoutFragment) {
                return ['/']
                    .concat(linkWithoutFragment.split('/'))
                    .filter((i) => i);
            }
            return ['/'].concat(linkItem.link.split('/')).filter((i) => i);
        }
        return [
            '/',
            this.languageService.getLanguageCode,
            page,
            linkItem.link.split('#').shift(),
        ];
    }

    isActiveLink(linkItem: LinkItem): boolean {
        return linkItem.link === this.slugService.getSlug();
    }

    isActiveSubLink(item: NavbarItem): boolean {
        return item.subLinkItems.some((subLinkItem) =>
            this.isActiveLink(subLinkItem),
        );
    }

    getFragmentFromLinkItem(linkItem: LinkItem): string | undefined {
        if (linkItem.link.includes('#')) {
            return linkItem.link.split('#').pop();
        }
        return undefined;
    }

    handleNavbarLinkClick(item: LinkItem): void {
        this.umami.track('navbar-link-click', {
            link: item.link,
            text: item.text,
        });
    }
}
